import useScrollReveal from "@/hooks/useScrollReveal";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Ticker from "@/pages/home/components/Ticker";
import Stats from "@/pages/home/components/Stats";
import Features from "@/pages/home/components/Features";
import ComicLibrary from "@/pages/home/components/ComicLibrary";
import ReadingExperience from "@/pages/home/components/ReadingExperience";
import AppDownload from "@/pages/home/components/AppDownload";
import LatestAddress from "@/pages/home/components/LatestAddress";
import Guide from "@/pages/home/components/Guide";
import Faq from "@/pages/home/components/Faq";
import CtaBand from "@/pages/home/components/CtaBand";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  useScrollReveal();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Ticker />
        <Stats />
        <Features />
        <ComicLibrary />
        <ReadingExperience />
        <AppDownload />
        <LatestAddress />
        <Guide />
        <Faq />
        <CtaBand />
      </main>
      <Footer />
    </div>
  );
}